import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import * as actions from "../../_redux/person-assignment/PersonAssignmentAction";
import { CustomSelect, NoticeReceipentType, NoticeReceipentTypeOptions, redirectToPages, UserType, UserTypeOptions } from "../../../../../_helpers/Helpers";
import { 
  Card,
  CardBody,
  CardHeader,
  ModalProgressBar
} from "../../../../../_metronic/_partials/controls";
import { TeachersPage } from "./teachers/TeachersPage";

export function PersonAssignmentPage({ history }) {
  const [noticeGroupId, setNoticeGroupId] = useState();
  const [receipentType, setReceipentType] = useState();

  // Getting curret state of Person Assignment from store (Redux)
  const dispatch = useDispatch();
  const { actionsLoading, isSuccess, type, noticeGroups } = useSelector(
    (state) => ({
      actionsLoading: state.personAssignment.actionsLoading,
      isSuccess: state.personAssignment.isSuccess,
      type: state.personAssignment.type,
      noticeGroups: state.personAssignment.noticeGroups
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getNoticeGroups());
    return () => dispatch(actions.cleanPersonIds());
  }, [dispatch]);

  // Yetki ve Hata Kontrolleri
  if (isSuccess === false) return redirectToPages(type);

  const userTypeOptions = UserTypeOptions.filter(option => option.value !== UserType.System);
  
  return (
    <>
      <Card>
        {actionsLoading && <ModalProgressBar />}
        <CardHeader title="Kişi Atama" />
        <CardBody>
          <div className="form-group row">
            <div className="col-3 mt-3">
              Duyuru Grubu <span>*</span>
            </div>
            <div className="col-4">
              <CustomSelect
                options={noticeGroups}
                onChange={option => {
                  if (receipentType) dispatch(actions.getPersonIds(option.value, receipentType));
                  setNoticeGroupId(option.value);
                }}
              />
            </div>
          </div>

          <div className="form-group row">
            <div className="col-3 mt-3">
              Kişiler <span>*</span>
            </div>
            <div className="col-4">
              <CustomSelect
                options={NoticeReceipentTypeOptions}
                onChange={option => {
                  if (noticeGroupId) dispatch(actions.getPersonIds(noticeGroupId, option.value));
                  setReceipentType(option.value);
                }}
              />
            </div>
          </div>
        </CardBody>
      </Card>
      {/* {
        userType === UserType.Personnel &&
        <PersonnelUsersPage
          history={history}
          userGroupId={userGroupId}
          userType={userType}
        />
      } */}
      {
        receipentType === NoticeReceipentType.Teacher &&
        <TeachersPage
          history={history}
          noticeGroupId={noticeGroupId}
          receipentType={receipentType}
        />
      }
      {/* {
        userType === UserType.Student &&
        <StudentUsersPage
          history={history}
          userGroupId={userGroupId}
          userType={userType}
        />
      }
      {
        userType === UserType.Parent &&
        <ParentUsersPage
          history={history}
          userGroupId={userGroupId}
          userType={userType}
        />
      } */}
    </>
  );
}